import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import authReducer from '@/core/global-store/features/auth/authSlice';
import uiReducer from '@/core/global-store/features/ui/uiSlice';
import bookingsReducer from '@/core/global-store/features/bookings/bookingsSlice';

const rootReducer = combineReducers({
    auth: authReducer,
    ui: uiReducer,
    bookings: bookingsReducer,
});

const store = configureStore({
    reducer: rootReducer,
});

export default store;
export type IRootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<IRootState>();
